<template>
<div>
  <sui-segment v-if="mode == 'view'">
	  <sui-header>
		  <v-row>
			  <v-col cols=12 md=5>
		  <h2>{{current.firstname}} {{current.lastname}} - ({{current.email}})</h2>
			</v-col>
			  <v-col cols=12 md=1></v-col>
			  <v-col cols=12 md=6 style="text-align:right">
				<div v-if="isAdmin">
					<v-btn :disabled="!canEdit()" color="orange" @click.prevent="handleEdit"><v-icon>mdi-pen</v-icon></v-btn>&nbsp;
					<v-btn :disabled="!canEdit()" color="red"  @click.prevent="handleDelete"><v-icon>mdi-trash-can</v-icon></v-btn>
				</div>
			</v-col>
		</v-row>
	  </sui-header>
	  <sui-divider></sui-divider>
		  <v-row>
			  <v-col cols=12 md=5>
				      <v-avatar
					color="indigo"
					size="69"
					>
					<span class="white--text text-h5">{{current.firstname[0]+current.lastname[0]}}</span>
					</v-avatar> {{current.firstname}} {{current.lastname}}
					<sui-divider></sui-divider>

				<v-simple-table dense>
				<template v-slot:default>
				<tbody>
					<!-- <tr><td>{{$t("name")}}: {{ current.firstname }} {{current.lastname}}</td></tr> -->
					<tr><td>{{$t("email")}}: {{ current.email }}</td></tr>
					<tr><td>{{$t("gender")}}: {{ $t('gender'+current.gender) }}</td></tr>
					<tr><td>{{$t("company")}}: {{ current.company }}</td></tr>
					<tr><td>{{$t("phone")}}: {{ current.phone }}</td></tr>
				</tbody>
				</template>
			</v-simple-table>


			  </v-col>
			  <v-col cols=12 md=1></v-col>
			  <v-col cols=12 md=6>
				<!-- <p style="max-height:40%; overflow-y: scroll">{{current.description}}</p> -->
				<br>
				<h3>{{$t('role')}}</h3>
                <v-chip
                  style="margin-right: 12px"
                  v-for="role in current.roles"
                  :key="role.id"
				  color="cyan lighten-2"
                  >{{ $t(role.name) }}</v-chip
                >
				<sui-divider></sui-divider>
				<h3>{{$t('groups')}}</h3>
                <v-chip
                  style="margin-right: 12px"
                  v-for="group in current.groups"
                  :key="group.id"
				  :color="group.color"
                  >{{ group.name }}</v-chip
                >
				<br>
		<sui-divider></sui-divider><br>
				</v-col>
		  </v-row>
		  <div v-if="current.checkedout != null && current.checkedout.length > 0">
			<sui-divider></sui-divider>
			  <v-simple-table max-height="300px">
				<template v-slot:default>
				<thead>
					<tr>
					<th class="text-left">
						{{$t('view')}}
					</th>	
					<th class="text-left">
						{{$t("name")}}
					</th>
					<th class="text-left">
						{{$t("productID")}}
					</th>
					<!-- <th class="text-left">
						{{$t("price")}}
					</th> -->
					<th class="text-left">
						{{$t("amount")}}
					</th>
					<th class="text-left">
						{{$t("extras")}}
					</th>
					<th class="text-left">
						{{$t("bought")}}
					</th>
					<th class="text-right">
						{{$t("status")}}
					</th>
					</tr>
				</thead>
				<tbody v-if="current.checkedout.length > 0">
					<tr
					v-for="item in current.checkedout"
					:key="item.product_id"
					>
					<td> <v-btn
								small
								:title="$t('view')"
								@click.prevent="$router.push('/product/'+item.product_id)"
								color="green">
								<v-icon dark>
									mdi-eye
								</v-icon>
								</v-btn> </td>	
					<td>{{ item.prod.name }}</td>
					<td>{{ item.product_id }}</td>
					<!-- <td>{{ new Intl.NumberFormat("de-DE", {style: "currency",  currency: "EUR", }).format(item.price ) }}</td> -->
					<td>{{ item.amount }}</td>
					<td>
						{{renderExtras(item)}}
					</td>
					<td>{{renderTime(item.created_at)}}</td>
					<td v-if="item.status == null || item.status == 'pending'" class="text-right"> <v-btn class="mx-2"
								small
								:title="$t('accept')"
								@click.prevent="handleUpdateStatus(item, 'accepted')"
								color="green">
								<v-icon dark>
									mdi-check
								</v-icon>
								</v-btn><v-btn class="mx-2"
								small
								@click.prevent="initDeclItem(item)"
								:title="$t('decline')"
								color="red">
								<v-icon dark>
									mdi-cancel
								</v-icon>
								</v-btn>
								</td>
					<td v-else class="text-right">
						<div :title='(item.status != "declined" ? $t("acceptedBY") : $t("declinedBY"))+": " +item.accepted_by + " " + $t("dayAt") + " "
						 + renderTime(item.updated_at)' :color="item.status != 'declined' ? 'green':'red'">
						 <span :class="'status-'+item.status">{{$t(item.status)}}</span> <br v-if="item.comment != null && item.comment != ''">{{item.comment != null && item.comment != '' ? $t('comment') +": " + item.comment : ""}}
						 <v-btn class="mx-2"
						 		v-if="item.status == 'accepted'"
								small
								@click.prevent="handleUpdateStatus(item, 'closed')"
								:title="$t('close')"
								color="green">
								<v-icon dark>
									mdi-package-variant-closed
								</v-icon>
								</v-btn>
						 </div>
					</td>
					</tr>
				</tbody>
				</template>
			</v-simple-table>
		</div>
	    <v-overlay :value="loading"
		absolute="true">
      <v-progress-circular
        indeterminate
        size="64"
      ></v-progress-circular>
    </v-overlay>


  </sui-segment>


	<!-- Edit -->

  <sui-segment v-else>
	  <sui-header>
		  <v-row>
			<v-col cols=12 md=1>
					<v-btn color="green"  @click.prevent="handleView"><v-icon>mdi-eye</v-icon></v-btn></v-col>
			  <v-col cols=12 md=5>
		  <!-- <h2>{{$t(current.name)}}</h2> -->
		  <!-- <v-text-field large :label="$t('name')" v-model="edit.name"></v-text-field> -->
		  <h2>{{$t("edit")}}: {{current.firstname}} {{current.lastname}} - ({{current.email}})</h2>
			</v-col>
			  <v-col cols=12 md=1></v-col>
			  <v-col cols=12 md=5 style="text-align:right">
					<v-btn color="red"  @click.prevent="handleDelete"><v-icon>mdi-trash-can</v-icon></v-btn>
			</v-col>
		</v-row>
	  </sui-header>
	  <sui-divider></sui-divider>
		  <v-row>
			  <v-col cols=12 md=5>
		  <v-row>
				      <v-avatar
					color="indigo"
					size="69"
					>
					<span class="white--text text-h5">{{(edit.firstname != null && edit.firstname != "" ? edit.firstname[0] : "?")+(edit.lastname != ""&& edit.lastname != null ? edit.lastname[0]:"?")}}</span>
					</v-avatar>&nbsp;
					<v-text-field :rules="rules.required" v-model="edit.firstname" :label="$t('firstname')"></v-text-field>&nbsp;
					<v-text-field :rules="rules.required" v-model="edit.lastname" :label="$t('lastname')"></v-text-field>
					<sui-divider></sui-divider></v-row>
				<br>
					<v-text-field :rules="rules.email" v-model="edit.email" :label="$t('email')"></v-text-field>
					        <v-select
							v-model="edit.gender"
							:items="genders"
							item-text="name"
							item-value="value"
							:label="$t('gender')"
							persistent-hint
							return-object
							single-line
							></v-select>
					<v-text-field v-model="edit.company" :label="$t('company')"></v-text-field>
					<v-text-field v-model="edit.phone" :label="$t('phone')"></v-text-field>
			  </v-col>
			  <v-col cols=12 md=1></v-col>
			  <v-col cols=12 md=6>
				<br>
				<h3>{{$t('role')}}</h3>
                <v-chip
                  style="margin-right: 12px"
                  v-for="role in current.roles"
                  :key="role.id"
				  color="cyan lighten-2"
                  >{{ $t(role.name) }}</v-chip
                >
				<sui-divider></sui-divider>
				<h3>{{$t('groups')}}</h3>
			<v-combobox
         	v-model="edit.groups"
          	:items="groups"
          	multiple
			  :placeholder="$t('groups')"
		  	item-key="id"
			item-text="name"
          	chips>
          <template v-slot:selection="data">
            <v-chip
			:color="data.item.color"
            >
              {{ data.item.name }}
            </v-chip>
          </template>
        </v-combobox>
				
				<br>
		<sui-divider></sui-divider><br>
					<v-btn color="green" :loading="buyLoading" block @click.prevent="saveEdit" x-large>{{$t('save')}}</v-btn>
					<template v-slot:loader>
						<span class="custom-loader">
						<v-icon light>mdi-cached</v-icon>
						</span>
					</template>
				</v-col>
		  </v-row>
	    <v-overlay :value="loading"
		absolute="true">
      <v-progress-circular
        indeterminate
        size="64"
      ></v-progress-circular>
    </v-overlay>

  </sui-segment>
  <v-dialog v-model="showDialog" width=900>
	  <v-card>
        <v-card-title class="text-h5 grey lighten-2">
                {{ $t("addComment")}}
              </v-card-title>
              <v-card-text>
				  	<v-text-field :placeholder="$t('comment')" v-model="comment"></v-text-field>
					<v-btn color="green" :loading="userLoading" block @click.prevent="handleUpdateStatus(closeItem, 'declined')">{{$t('save')}}</v-btn>
					<template v-slot:loader>
						<span class="custom-loader">
						<v-icon light>mdi-cached</v-icon>
						</span>
					</template>
			  </v-card-text>
			</v-card>
  </v-dialog>
  </div>
</template>

<script>
import ApiService from "@/services/ApiService.js";
import DateService from "@/services/DateService.js";
import PermissionService from "@/services/PermissionService.js";
export default {
	data() {
		return {
			current: {
				firstname: " ",
				lastname: " ",
				email: "@",
				gender: " ",
				phone: " ",
				company: " "
			},
			loading: false,
			mode: "view",
			comment: "",
			closeItem: {},
			id: 0,
			isAdmin: false,
			showDialog: false,
			edit: {},
			groups: [],
			rules: {
				email:[v => /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(String(v).toLowerCase()) && v.length > 0|| this.$t('errorNoEmail')],
				required: [v => v.length > 0 || this.$t("required")]
				},
			genders: [
				{name: this.$t('gender3'), value:"3"},
				{name: this.$t('gender1'), value:"1"},
				{name: this.$t('gender2'), value:"2"},
			]
		}
	},
	async created(){
		this.id = this.$route.params.id
		this.isAdmin =PermissionService.checkPermission("view user", false)
		this.loading = true;		
		if(this.$route.query.edit){
			this.mode = "edit";
        	window.history.replaceState({},document.title,window.location.origin + window.location.pathname)
		}
		this.renderContent();
		let res = await ApiService.getGroups()
		this.groups = res.data
	},
	methods: {
		canEdit(){
			if(this.current.role != null &&this.current.role[0] != "customer"){
					if(this.$store.getters.role.name != "shopadmin"){
						return false;
					}
				}
			return true;
		},
		async renderContent(){
			this.loading = true
			let res = await ApiService.getUser(this.id)
			if(res.status == 200){

				if(this.mode == "edit"&&res.data.role[0] != "customer"){
					if(this.$store.getters.role.name != "shopadmin"){
						this.$router.push("/management/users");
						this.$swal({
							icon: "error",
							title: this.$t("error"),
							text: this.$t("noPerm")
						})
					}
				}


				this.current = res.data
				if(this.mode == "edit"){
					this.edit = JSON.parse(JSON.stringify(this.current))
				}
				this.newPrice = this.current.price
				this.loading = false
			}
		},
		initDeclItem(item){
			this.closeItem = item
			this.comment = ""
			this.showDialog = true
		},
		renderTime(time){
			return DateService.toHumanDate(time)
		},
		renderExtras(item){
			if(item.size == null && item.color == null){
				return this.$t("noData")
			}
			let out = "";
			if(item.size){
				out += this.$t("size") + ": " + item.size
			}
			if(item.color){
				out == "" ? "" : out += ", "
				out += this.$t("color") + ": " + item.color
			}
			return out;
		},
        async handleDelete(){
			if(this.current.role != null &&this.current.role[0] != "customer"){
					if(this.$store.getters.role.name != "shopadmin"){
						this.$swal({
							icon: "error",
							title: this.$t("error"),
							text: this.$t("noPerm")
						})
						return;
					}
				}
            this.$swal.fire({
                icon: "warning",
                title: this.$t("areYouSure"),
                text: this.$t("youCantRevert"),
                showCancelButton: false,
                showDenyButton: true,
                confirmButtonText: this.$t('yesDelete'),
                denyButtonText: this.$t("noKeep")
                }).then(async(result) => {
                if (result.isConfirmed) {
                    let res = await ApiService.deleteUser(this.current.id);
                    if (res===false) {
						this.$router.push("/management/users");
                        this.updateTable++
                        this.$swal({
                            icon: "success",
                            title: this.$t("deleted"),
                            text: this.$t("deleteSuccess")
                        })
                    }
                }
            })
        },
		handleEdit(){
			this.edit = JSON.parse(JSON.stringify(this.current))
			// this.edit = temp
			// temp = null
			if(this.current.role != null &&this.current.role[0] != "customer"){
					if(this.$store.getters.role.name != "shopadmin"){
						this.$swal({
							icon: "error",
							title: this.$t("error"),
							text: this.$t("noPerm")
						})
						return;
					}
				}
			this.mode = 'edit'
		},
		handleView(){
			this.mode = 'view'
		},
		async handleUpdateStatus(item = null, status){
			if(status != "declined"){
				let res = await ApiService.updateStatus(item.id, {status: status})
				if(res.status == 201){
					this.renderContent()
					this.$emit("updateNotis")
				}
			}else{
				this.showDialog = false
				let res = await ApiService.updateStatus(item.id, {status: status, comment: this.comment})
				if(res.status == 201){
					this.renderContent()
					this.$emit("updateNotis")
				}
			}
		},
		async saveEdit(){
			this.loading = true;
			this.buyLoading = true;
			let res = await ApiService.putUser(this.edit.id,{
				"firstname": this.edit.firstname,
				"lastname": this.edit.lastname,
				"email": this.edit.email,
				"phone": this.edit.phone,
				"gender": this.edit.gender.value,
				"company": this.edit.company,
				"groups": this.edit.groups
			})
			if(res.status == 200){
				this.loading = false;
			this.buyLoading = false;


				this.current = res.data
				this.edit = this.current
				this.$swal({
					icon: "success",
					title: this.$t("yea"),
					text: this.$t("saved")
				})
			}else{
				this.loading = false;
			this.buyLoading = false;
				this.$swal({
					icon: "error",
					title: this.$t("error"),
					text: this.$t(res.data.message)
				})
			}
		}
	},
	
  watch: {
    "$route.params.id":  function () {
		this.id = this.$route.params.id
		this.renderContent()
	}
  }
}
</script>

<style>
.extra {
	margin-right:2%;
}
img {
	max-width: 850px;
	max-height: 850px;
}
.status-declined {
	color: red;
}
.status-accepted {
	color: green;
}
.status-closed {
	color: green;
}
</style>